<template>
	<sf-data-table
		ref="PwaApcnTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="roApcnCols"
		:rows="rows"
		:stripe="false"
		index
		@changedPage="changedPage"
		height="650px"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/PwaApcn/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.pwaApcnList;
		},
		roApcnCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC000969'), //PWN No
					prop: 'pwaNo',
					minWidth: '200px',
					sortable: false,
					highlight: true,
					clickEvent: this.ClickPwaNo
				},
				{
					label: this.getMessage_('QWCC000970'), // 딜러점코드
					prop: 'dlrCpnyCd',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000959'), // 딜러점
					prop: 'dlrCpnyNm',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000960'), // 차량VIN
					prop: 'carVin',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000972'), // 주행거리
					prop: 'milg',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000973'), // 기종
					prop: 'flclSpcNm',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001538'), // PMC Id
					prop: 'pmcId',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000975'), // 원인부품번호
					prop: 'causPartNo',
					minWidth: '200px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000963'), // 처리단계
					prop: 'prcsStepNm',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000978'), // 처리결과
					prop: 'prcsRsltNm',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000979'), // 신청일자
					prop: 'aplcDd',
					minWidth: '150px',
					sortable: true
				},
				{
					label: this.getMessage_('MWCC000980'), // 확정일자
					prop: 'dcsnDd',
					minWidth: '150px',
					sortable: true
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		async ClickPwaNo(row) {
			const pwaSelectedRow = row;
			//console.log('pwaSelectedRow', pwaSelectedRow);
			await this.$emit('pwaSelectedRow', row);
		}
	}
};
</script>

<style></style>
